var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("form", { attrs: { "data-vv-scope": "uploadFiles" } }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-9 mt-5" }, [
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c("b-form-select", {
                staticClass: "w-100 mt-2 mr-4",
                attrs: { options: _vm.optionsUploadTypes },
                model: {
                  value: _vm.uploadType,
                  callback: function($$v) {
                    _vm.uploadType = $$v
                  },
                  expression: "uploadType"
                }
              }),
              _c("UploadFile", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: "Agregar archivo adjunto",
                    expression: "'Agregar archivo adjunto'"
                  }
                ],
                staticClass: "mt-2 mr-3",
                attrs: {
                  "data-cy": "file-upload",
                  permission: "*",
                  accept: _vm.uploadType === "main" ? "application/pdf" : "",
                  text: "Seleccionar",
                  "upload-to": "ed"
                },
                on: {
                  input: function($event) {
                    return _vm.addNewFile()
                  }
                },
                model: {
                  value: _vm.newFile,
                  callback: function($$v) {
                    _vm.newFile = $$v
                  },
                  expression: "newFile"
                }
              })
            ],
            1
          ),
          !!_vm.error
            ? _c("div", [
                _c("small", { staticClass: "text-danger" }, [
                  _vm._v(_vm._s(_vm.error))
                ])
              ])
            : _vm._e()
        ]),
        _vm.thereIsMainFile
          ? _c(
              "div",
              { staticClass: "col-12 mt-5" },
              [
                _c(
                  "b-table-simple",
                  { attrs: { hover: "", small: "" } },
                  [
                    _c(
                      "b-thead",
                      [
                        _c(
                          "b-tr",
                          [
                            _c("b-th", { attrs: { scope: "col" } }, [
                              _vm._v("Nombre archivo")
                            ]),
                            _c("b-th", { attrs: { scope: "col" } }, [
                              _vm._v("Nombre documento")
                            ]),
                            _c(
                              "b-th",
                              {
                                staticClass: "text-center",
                                attrs: { scope: "col" }
                              },
                              [_vm._v("Acción")]
                            ),
                            _vm.withTrueCopy ||
                            _vm.$route.params.from === "edit"
                              ? _c(
                                  "b-th",
                                  {
                                    staticClass: "text-center",
                                    attrs: { scope: "col" }
                                  },
                                  [_vm._v(" Tipo ")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "b-tr",
                      [
                        _c("b-td", [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: "Principal",
                                  expression: "'Principal'"
                                }
                              ],
                              staticClass: "d-flex align-items-center"
                            },
                            [
                              _c("vs-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "file_present", size: "medium" }
                              }),
                              _vm._v(" " + _vm._s(_vm.mainFile.name) + " ")
                            ],
                            1
                          )
                        ]),
                        _c(
                          "b-td",
                          [
                            _c("vs-input", {
                              staticClass: "w-100",
                              model: {
                                value: _vm.mainFile.currentDescription,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.mainFile,
                                    "currentDescription",
                                    $$v
                                  )
                                },
                                expression: "mainFile.currentDescription"
                              }
                            })
                          ],
                          1
                        ),
                        _c("b-td"),
                        _vm.withTrueCopy || _vm.$route.params.from === "edit"
                          ? _c(
                              "b-td",
                              { staticClass: "text-center" },
                              [
                                _c("b-form-select", {
                                  attrs: { options: _vm.trueCopyOptions },
                                  model: {
                                    value: _vm.mainFile.trueCopy,
                                    callback: function($$v) {
                                      _vm.$set(_vm.mainFile, "trueCopy", $$v)
                                    },
                                    expression: "mainFile.trueCopy"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._l(_vm.additionalFiles, function(file) {
                      return _c(
                        "b-tr",
                        { key: file.id },
                        [
                          _c("b-td", [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Adjunto",
                                    expression: "'Adjunto'"
                                  }
                                ],
                                staticClass: "d-flex align-items-center"
                              },
                              [
                                _c("vs-icon", {
                                  staticClass: "mr-1",
                                  attrs: { icon: "description", size: "medium" }
                                }),
                                _vm._v(" " + _vm._s(file.name) + " ")
                              ],
                              1
                            )
                          ]),
                          _c(
                            "b-td",
                            [
                              _c("vs-input", {
                                staticClass: "w-100",
                                model: {
                                  value: file.currentDescription,
                                  callback: function($$v) {
                                    _vm.$set(file, "currentDescription", $$v)
                                  },
                                  expression: "file.currentDescription"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "b-td",
                            { staticClass: "text-center" },
                            [
                              _c("vs-icon", {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Eliminar",
                                    expression: "'Eliminar'"
                                  }
                                ],
                                staticClass: "cursor-pointer",
                                attrs: {
                                  color: "danger",
                                  "data-cy": "remove-attachment",
                                  icon: "remove_circle_outline",
                                  size: "small"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeAdditionalFile(file.id)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm.withTrueCopy || _vm.$route.params.from === "edit"
                            ? _c(
                                "b-td",
                                { staticClass: "text-center" },
                                [
                                  _c("b-form-select", {
                                    attrs: { options: _vm.trueCopyOptions },
                                    model: {
                                      value: file.trueCopy,
                                      callback: function($$v) {
                                        _vm.$set(file, "trueCopy", $$v)
                                      },
                                      expression: "file.trueCopy"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              ],
              1
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }